const SPREADSHEET_FORMULA_PREFIXES = ["=", "+", "-", "@"] as const;

export function sanitizeSpreadsheetCell(value: string): string {
  if (SPREADSHEET_FORMULA_PREFIXES.some((prefix) => value.startsWith(prefix))) {
    return `'${value}`;
  }

  return value;
}
